"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    Badge: null,
    Icon: null,
    Label: null,
    VectorIcon: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Badge () {
        return Badge;
    },
    get Icon () {
        return Icon;
    },
    get Label () {
        return Label;
    },
    get VectorIcon () {
        return VectorIcon;
    }
});
function Badge(props) {
    return null;
}
function Icon(props) {
    return null;
}
function VectorIcon(props) {
    return null;
}
function Label(props) {
    return null;
}

//# sourceMappingURL=elements.js.map
